module.exports = __webpack_public_path__ + "assets/img/brand-01.d97354a2.png";